// filepath: apps/web/src/features/admin/PendingReviewBanner.tsx
//
// FR-UI-ADM-1 AC-3 — pending-promotion-review banner.
//
// Renders above the matrix grid when the editor has saved changes to
// staging and the FR-PROM-1 diff engine has produced a pending
// `permission`-typed promotion review. The banner links to the
// FR-UI-PROM-1 diff page so the reviewer opens the existing
// approve/reject surface (no new review surface is built).

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

interface PendingReviewBannerProps {
  /** Pending review count. Null while loading. */
  pendingCount: number | null;
  /** Click handler that navigates to the PromotionDiffPage. */
  onOpenPromotion: () => void;
}

export function PendingReviewBanner({
  pendingCount,
  onOpenPromotion,
}: PendingReviewBannerProps): React.ReactElement | null {
  const { t } = useTranslation();

  if (pendingCount === null || pendingCount <= 0) return null;

  return (
    <div
      className="rounded border border-yellow-300 bg-yellow-50 px-3 py-2 text-sm text-yellow-900"
      role="status"
      data-testid="pending-review-banner"
    >
      <span>
        {t("admin.matrix.banner.pending_review")} ({pendingCount})
      </span>
      <button
        type="button"
        className="ml-3 rounded border border-yellow-400 px-2 py-1 text-xs font-medium hover:bg-yellow-100"
        onClick={onOpenPromotion}
        data-testid="pending-review-open"
      >
        {t("admin.matrix.banner.open_review")}
      </button>
    </div>
  );
}
